import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ReportPropertyDetailConstant } from './residential-property-detail.constant';
import { SharedService } from 'src/app/common/services/shared.service';
import { PropertyDetailMenuEnum } from './residential-property-detail.enum';
import { ReportPropertyDetailService } from './residential-property-detail.service';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { ReportService } from 'src/app/reports/services/report.service';
import { Subscription } from 'rxjs';
import { ReportsViewEnum } from 'src/app/reports/models/enums/reports.enum';
import { PropertyCategoryEnum } from '../../propertyCategory.enum';
import { countryCode } from 'src/app/common/constants/common.contants';

@Component({
  selector: 'app-residential-property-detail',
  templateUrl: './residential-property-detail.component.html',
  styleUrls: ['./residential-property-detail.component.scss']
})
export class ResidentialPropertyDetailComponent implements OnChanges, OnDestroy, OnInit, AfterViewInit {

  @Input() propertyInfo: any;
  propertyDetail: any = null;
  currentReportView: number = ReportsViewEnum.mapView;
  propertyCategory = PropertyCategoryEnum;
  overViewMenu = ReportPropertyDetailConstant.overViewMenu;
  currentScroll: any = PropertyDetailMenuEnum.overview;;

  propertyDetailMenuEnum = PropertyDetailMenuEnum;
  reportName: string = '';
  currentLang: string = '';
  languageSub$: Subscription = new Subscription();
  currentReportView$: Subscription = new Subscription();
  isSaudiCheck!: boolean;
  @ViewChild('navBar') navBar: ElementRef | any;
  showPropertyInfomation = true;
  showAmenities = true;
  showBuildUpinfo = true;
  showResidentialUnits =true;
  showLandDetails =true;
  showUnitsTrasaction =true;
  showPropertyTrasaction =true;
  showResidentailIncome =true;
  showCommercialIncome =true;
  showNearbyRental =true;

  constructor(
    private sharedService: SharedService,
    private reportPropertyDetailService: ReportPropertyDetailService,
    public reportService: ReportService,

  ) { }

  ngOnInit(): void {
    this.isSaudiCheck = this.sharedService.getStoreValue(GlobalContants.StoreKey.countryCode) === countryCode.saudi;
      if(this.isSaudiCheck){
        this.overViewMenu.map((menu) => {
          if(menu.name === PropertyDetailMenuEnum.NearByRentalAndOccupancy) {
            menu.label = 'reports.nearbyRentals'
          }
        })
      }else{
        this.overViewMenu.map((menu) => {
          if(menu.name === PropertyDetailMenuEnum.NearByRentalAndOccupancy) {
            menu.label = 'reports.nearbyRentalsAndOccupancy'
          }
        })
    }
    this.setLang();
    this.getReportView();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.reportPropertyDetailService.propertyInfo = this.propertyInfo;
    this.reportPropertyDetailService.userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.reportPropertyDetailService.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
    this.reportPropertyDetailService.CurrencyCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode);
    this.scrollPoint(String(this.propertyDetailMenuEnum.overview));
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.scrollPoint(String(this.propertyDetailMenuEnum.overview));
    }, 0);
  }


  setLang(): void {
    this.languageSub$ = this.sharedService.language$.subscribe(lang => {
      this.currentLang = lang;
    })
  }

  getReportView() {
    this.currentReportView$ = this.reportService.reportView$.subscribe((view: number) => {
      this.currentReportView = view;
    });
  }

  menuChangeValue(menu: any) {
    this.currentScroll = menu.name;
    setTimeout(() => {
      this.scrollPoint(menu.name);
    })
  }

  scrollPoint(menu: string) {
    this.sharedService.scrollMenu(menu);
  }

  backToTransaction() {
    if(!this.reportService.projectReportView){
       this.reportService.isDetailPageOpen = false;
    }  
    this.reportService.transactionPropertyDetails.next(false);
    // this.reportService.isDetailPageOpen = false;
    // this.reportService.transactionPropertyDetails.next(false);
  }
  viewSection(e:any, section:string=''){
    if(section == 'PropertyInfomation'){
      this.showPropertyInfomation = e;
      if(!this.showPropertyInfomation){
        this.overViewMenu = this.overViewMenu.filter(x => x.name !== PropertyDetailMenuEnum.propertyInformation);
      }
    }
    
    if(section == 'BuildUpInfo'){
      this.showBuildUpinfo = e;
      if(!this.showBuildUpinfo){
        this.overViewMenu = this.overViewMenu.filter(x => x.name !== PropertyDetailMenuEnum.builtInformation);
      }
    }
    if(section == 'Amenities'){
      this.showAmenities = e;
      if(!this.showAmenities){
        this.overViewMenu = this.overViewMenu.filter(x => x.name !== PropertyDetailMenuEnum.amentities);
      }
    }
    if(section == 'ResidentialUnits'){
      this.showResidentialUnits = e;
      if(!this.showResidentialUnits){
        this.overViewMenu = this.overViewMenu.filter(x => x.name !== PropertyDetailMenuEnum.unit);
      }
    }
    if(section == 'LandDetails'){
      this.showLandDetails = e;
    
    }
    // if(section == 'UnitsTrasaction'){
    //   this.showUnitsTrasaction = e;
    //   if(!this.showUnitsTrasaction){
    //     this.overViewMenu = this.overViewMenu.filter(x => x.name !== PropertyDetailMenuEnum.unitTransaction);
    //   }
    // }
    // if(section == 'PropertyTrasaction'){
    //   this.showPropertyTrasaction = e;
    //   if(!this.showPropertyTrasaction){
    //     this.overViewMenu = this.overViewMenu.filter(x => x.name !== PropertyDetailMenuEnum.propertyTransaction);
    //   }
    // }
    if(section == 'ResidentailIncome'){
      this.showResidentailIncome = e;
      if(!this.showResidentailIncome){
        this.overViewMenu = this.overViewMenu.filter(x => x.name !== PropertyDetailMenuEnum.rentalIncome);
      }
    }
    if(section == 'CommercialIncome'){
      this.showCommercialIncome = e;
      if(!this.showCommercialIncome){
        this.overViewMenu = this.overViewMenu.filter(x => x.name !== PropertyDetailMenuEnum.commercialRentalIncome);
      }
    }
    if(section == 'NearbyRental'){
      this.showNearbyRental = e;
      if(!this.showNearbyRental){
        this.overViewMenu = this.overViewMenu.filter(x => x.name !== PropertyDetailMenuEnum.NearByRentalAndOccupancy);
      }
    }
    
    
  }
  isAmenities(e:any){
   
  }

  ngOnDestroy(): void {
    this.reportPropertyDetailService.propertyInfo = null;
    this.languageSub$?.unsubscribe()
    this.currentReportView$?.unsubscribe()
  }


}
